import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';

// import services object here...
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { PagerService } from '../pagination/pager.service';
import { TechTrainingManualService } from './tech-training-manual.service';

// import all Model objects or interfaces Goes here...
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { TechTrainingManual } from '../../core/models/tech-training-manual';

import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../shared/pipes/sort-by-filter.pipe';

@Component({
    selector: 'app-tech-training-manual',
    templateUrl: './tech-training-manual.component.html',
    styleUrls: ['./tech-training-manual.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        NgStyle,
        FormsModule,
        NgFor,
        NgxPaginationModule,
        SearchFilterPipe,
        SortByFilterPipe,
    ],
})
export class TechTrainingManualComponent implements OnInit, OnDestroy {

  public allTechTrainingManuals: TechTrainingManual[] = [];
  public newTechTrainingManuals: TechTrainingManual[] = [];
  public recentTechTrainingManuals: TechTrainingManual[] = [];

  public techTrainHandleErr = new HandleError();
  public search4Manual;
  public p;
  private subsciptions: ISubscription[];
  APP_SETTINGS: any;
  // sorting asc/desc initialization
  records: Array<any>;
  isDesc = false;
  column = '';
  direction: number;

  screenWidth: number;

  // top control panel flags set to default
  showAllFlag = false;
  showNewFlag = true;
  showRecentFlag = false;
  totalNewCount = 0;

  userName: string;
  errorMessage: string;

  constructor(
    private spinnerService: SpinnerService,
    private techTrainingManualService: TechTrainingManualService,
    private changeDetector: ChangeDetectorRef,
    private utilityService: UtilityService,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private analyticsService: AnalyticsService,
    private pagerService: PagerService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    // this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
    //   this.userName = userData['email'];
    // });
    this.userName = this.authService.getUserName();
    this.subsciptions = [];
    this.APP_SETTINGS = APP_SETTINGS;
    APP_SETTINGS.currentPage = 'tech-training';
    // this.initialLoadAllTechnicalTrainingManuals();

    if (APP_SETTINGS.techTrainingManual == 'all') {
      this.showAllFlag = true;
      this.showAll();
    }
    if (APP_SETTINGS.techTrainingManual == 'new') {
      this.showNewFlag = true;
      this.showNew();
    }
    if (APP_SETTINGS.techTrainingManual == 'history') {
      this.showRecent();
    }
  }

  initialLoadNewTechnicalTrainingManuals() {
    this.showNewFlag = true;
    this.showNew();
  }

  initialLoadAllTechnicalTrainingManuals() {
    this.showAllFlag = true;
    this.showAll();
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  showAll() {
    // set the ALL active tab showing with BMW blue color
    this.showAllFlag = true;
    this.showNewFlag = false;
    this.showRecentFlag = false;
    this.errorMessage = '';
    APP_SETTINGS.techTrainingManual = 'all';
    // if (this.allTechTrainingManuals.length === 0) {

    // set the spinner to show and alter hide below
    this.spinnerService.show('bmwSpinner');
    // reset the error message from HandleError class
    HandleError.resetErrorMessage();

    // Eager load All technical training manuals
    this.techTrainingManualService.getAllTechTrainingManuals()
      .subscribe(data => {
        this.allTechTrainingManuals = data.content;
        this.totalNewCount = data.newSize;
        this.techTrainHandleErr.bmwAppError().flag = false;
        // array copy all
        this.pagerService.allItems = this.allTechTrainingManuals.map(item => Object.assign({}, item));
        this.pagerService.setPage(1);
        // this.showingAll();
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      }, (error) => {
        this.spinnerService.hide('bmwSpinner');
        HandleError.handleAPIError(error);
      }
      );
    // } else {
    //   this.showingAll();
    //   return;
    // }

  }

  showingAll() {
    this.pagerService.allItems = this.allTechTrainingManuals.map(item => Object.assign({}, item));
    // reset the pager object
    this.pagerService.pager = {};
    this.pagerService.setPage(1);
    this.errorMessage = '';
    // reset error message to not show
    this.techTrainHandleErr.bmwAppError().flag = false;
  }

  showNew() {
    // set the NEW active tab showing with BMW blue color
    this.showNewFlag = true;
    this.showAllFlag = false;
    this.showRecentFlag = false;
    APP_SETTINGS.techTrainingManual = 'new';

    // if (this.newTechTrainingManuals.length === 0) {

    // set the spinner to show and alter hide below
    this.spinnerService.show('bmwSpinner');
    // reset the error message from HandleError class
    HandleError.resetErrorMessage();

    // Eager load New technical training manuals
    this.techTrainingManualService.getNewTechTrainingManuals()
      .subscribe(data => {
        this.allTechTrainingManuals = data;
        this.techTrainHandleErr.bmwAppError().flag = false;
        this.totalNewCount = this.allTechTrainingManuals.length;
        if (this.totalNewCount === 0) {
          this.errorMessage = 'No New Records Found';
        }
        // this.showingNew();
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
      }, (error) => {
        this.spinnerService.hide('bmwSpinner');
        HandleError.handleAPIError(error);
      }
      );
    // } else {
    //   this.showingNew();
    //   return;
    // }

  }

  showingNew() {
    this.pagerService.allItems = this.newTechTrainingManuals.map(item => Object.assign({}, item));
    // reset the pager object 
    this.pagerService.pager = {};
    this.pagerService.setPage(1);

    // reset error message to not show
    this.techTrainHandleErr.bmwAppError().flag = false;

  }

  showRecent() {
    // set the RECENT active tab showing with BMW blue color
    this.showRecentFlag = true;
    this.showNewFlag = false;
    this.showAllFlag = false;
    this.errorMessage = '';
    APP_SETTINGS.techTrainingManual = 'history';
    //if (this.recentTechTrainingManuals.length === 0) {

    // set the spinner to show and alter hide below 
    this.spinnerService.show('bmwSpinner');
    // reset the error message from HandleError class  
    HandleError.resetErrorMessage();

    // Eager load Recent technical training manuals
    this.techTrainingManualService.getRecentTechTrainingManuals(this.userName)
      .subscribe(data => {
        this.allTechTrainingManuals = data;
        this.techTrainHandleErr.bmwAppError().flag = false;
        if (this.allTechTrainingManuals.length === 0) {
          this.errorMessage = 'No History Found';
        }
        // this.showingRecent();
        this.spinnerService.hide('bmwSpinner');
      }, (error) => {
        this.spinnerService.hide('bmwSpinner');
        HandleError.handleAPIError(error);
      }
      );
    //} else {
    //  this.showingRecent();
    //  return;
    // }

  }

  showingRecent() {
    this.pagerService.allItems = this.recentTechTrainingManuals.map(item => Object.assign({}, item));
    this.changeDetector.detectChanges();
    // reset the pager object 
    this.pagerService.pager = {};
    this.pagerService.setPage(1);

    // reset error message to not show
    this.techTrainHandleErr.bmwAppError().flag = false;

  }

  sortBy(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }

  addManualToHistory(isSaved, manualId, documentNumber) {

    if (!isSaved) {
      this.subsciptions.push(this.techTrainingManualService.addManualToUserHistory(this.userName, manualId).subscribe(data => {
      }));
    }

    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('Technical Training Manuals', documentNumber, this.userName);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Technical Training Manuals', documentNumber);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('Technical Training Manuals', documentNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Technical Training Manuals', documentNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
  }

  ngOnDestroy(): void {
    this.subsciptions.map(sub => sub.unsubscribe());
  }

  pageNumChange(event) {    
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
  
}
